export const span = (val: number) => ({
  flexBasis: `calc(${(val / 24) * 100}% - 24px)`,
  maxWidth: `calc(${(val / 24) * 100}% - 24px)`,
});
